import type { RecipientPhoneInfo, RecipientRoles } from '@/types/types';
import type { RecipientsShareHints, ShareLink } from './interfaces';
import appConfig from '@/config/env';

export const LINKS_PARALLEL_REQUESTS_LIMIT = 10;

export const EMPTY_RECIPIENT = '__NO_RECIPIENT__';

export const SHARING_HINT_TIMEOUT = 1800;

export const REFRESH_PERMISSIONS_TIMEOUT_MS = 3_000;

export const RECIPIENTS_HINTS_LIST: RecipientsShareHints[] = [
    'noRecipients',
    'missingRecipient',
    'missingRecipientInvalid',
];

export function getInviteAsDefault(): RecipientRoles {
    const val = appConfig.DEFAULT_SHARE_ROLE;
    if (val === 'viewer' || val === 'editor' || val === 'coOwner') return val;
    return 'editor';
}

export const INIT_SHARE_LINK_PARTIAL: Omit<ShareLink, 'recipientType'> = { link: '', isLoading: true };
